import React, { ReactElement } from 'react';
import { Space } from 'antd';

import ExportCsvData from 'leash/components/exportCsvData/ExportCsvData';
import { PackagesTableActiveFooterTools } from 'leash/types';
import { TravelPlan } from 'types';

interface Props {
  currentDataSource: TravelPlan[];
  activeFooterTools?: PackagesTableActiveFooterTools;
}

function PackagesTableFooterTools(props: Props): ReactElement | null {
  const { currentDataSource, activeFooterTools } = props;

  if (!activeFooterTools) {
    return null;
  }

  return (
    <Space style={{ paddingTop: '1rem' }}>
      {activeFooterTools.exportCSV && (
        <ExportCsvData data={currentDataSource} dataType="travelPackages" />
      )}
    </Space>
  );
}

export default PackagesTableFooterTools;
